import { render, staticRenderFns } from "./WebshopOrderSummary.vue?vue&type=template&id=b8db544e&scoped=true&"
import script from "./WebshopOrderSummary.vue?vue&type=script&lang=js&"
export * from "./WebshopOrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./WebshopOrderSummary.vue?vue&type=style&index=0&id=b8db544e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8db544e",
  null
  
)

export default component.exports